<template>
  <confirm-dialog
    v-show="isShow"
    :data="dialogData"
    name="uploadBannerCoverDialog"
    @confirm="handleConfirm"
  >
    <div class="box">
      <div class="row mx-auto">
        <div class="col-12 p-0 mt-4">
          <croppa
            ref="croppaImage"
            :accept="'image/*'"
            :placeholder="''"
            :file-size-limit="upload.MAX_FILE_SIZE_B"
            :width="300"
            :height="200"
            :show-remove-button="false"
            :replace-drop="true"
            :initial-image="thumbnailUrl"
            class="upload-box dropzone"
            @file-size-exceed="fileSizeExceed()"
            @file-choose="handleFileChoose"
          >
            <div class="upload-placeholder">
              <img :src="'/static/icons/button-add-cover.svg'" />
              <div>
                เพิ่มรูปภาพ<br /><br />
                (คลิก หรือลากไฟล์ลงในกรอบนี้)
              </div>
            </div>
          </croppa>
          <img
            v-if="showRemoveImage"
            src="/static/icons/cancel-black.svg"
            class="btn-remove pointer"
            @click="removeFile()"
          />
          <div class="remake">
            * ขนาดที่แนะนำคือ 1200 x 800 พิกเซล และ ขนาดไฟล์สูงสุดคือ 1 MB
          </div>
        </div>
      </div>
    </div>
  </confirm-dialog>
</template>

<script>
import { UPLOAD } from "@/config/constant"

export default {
  props: {
    thumbnailFile: {
      type: null,
      default: undefined,
    },
    thumbnailUrl: {
      type: null,
      default: undefined,
    },
    thumbnailKey: {
      type: null,
      default: undefined,
    },
    canEdit: {
      type: null,
      default: undefined,
    },
    isShow: {
      type: null,
      default: undefined,
    },
    isLoading: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      file: "",
      key: this.thumbnailKey,
      labels: {
        maxFileSize: UPLOAD.MAX_FILE_SIZE_MB,
      },
      fileChose: !!this.thumbnailUrl,
      upload: UPLOAD,
      fileChanged: false,
    }
  },
  computed: {
    dialogData() {
      const buttonSubmit = this.isLoading ? "กำลังดำเนินการ" : "เลือก"
      return {
        title: "เลือกภาพ Thumbnail",
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: this.isLoading || !this.fileChanged,
        disableCancel: this.isLoading,
        hideAction: !this.canEdit,
      }
    },
    initialImage() {
      if (!this.thumbnailFile && !this.thumbnailUrl) {
        return null
      }

      if (this.thumbnailFile) {
        return this.thumbnailFile
      }

      return this.thumbnailUrl
    },
    hasImage() {
      if (!this.$refs.croppaImage) {
        return false
      }

      return this.$refs.croppaImage.hasImage()
    },
    showRemoveImage() {
      return !!this.initialImage || this.fileChose
    },
  },
  watch: {
    isShow(value) {
      if (value) {
        this.$refs.croppaImage.refresh()
      }
    },
  },
  methods: {
    async handleConfirm(isConfirm) {
      this.fileChanged = false
      if (!isConfirm) {
        this.$emit("cancel")
        this.removeFile()
        return
      }

      if (!this.fileChose) {
        this.$emit("confirm")
        return
      }

      const blob = await this.$refs.croppaImage.promisedBlob()
      this.$emit("confirm", blob)
    },
    handleFileChoose(file) {
      this.file = file
      this.fileChose = true
      this.fileChanged = true
    },
    fileSizeExceed() {
      this.fileChose = false
      this.$message.error(
        `${this.$t("feature.upload.exceed_max_file_size")} ${
          UPLOAD.MAX_FILE_SIZE_MB
        } MB`,
      )
    },
    removeFile() {
      this.fileChose = false
      this.$refs.croppaImage.remove()
    },
  },
}
</script>

<style lang="scss" scoped>
#upload {
  background-color: rgba(74, 74, 74, 0.5);
}
.upload-box {
  position: relative;
  width: 300px;
  height: 200px;
  border: 2px dashed #d8d6d9;

  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  color: #8c8786;
  object-fit: thumbnail;

  margin: 0 auto;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.upload-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.upload-box.croppa--has-target .upload-placeholder {
  display: none;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  left: 0;
  width: 360px;
  height: 154px;
  position: absolute;
  cursor: pointer;
  z-index: 99;
}
.btn-remove {
  position: absolute;
  width: 25px;
  height: 25px;
  top: -10px;
  right: -10px;
}
.show-file {
  width: 360px;
  height: 154px;
}
.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}
</style>
